// extracted by mini-css-extract-plugin
export default {"card":"create-user_card__ND-uz","input":"create-user_input__Q14wG","button":"create-user_button__z0kdm"};